module.exports = __webpack_public_path__ + "static/media/demo_bamazonCustomer.2b5665ca.gif";